// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from "react";
import {
    TextField as SearchTextInput, makeStyles,
    Button, Switch, Chip
} from '@material-ui/core';
import { TextField, FunctionField, List, Datagrid, TopToolbar, downloadCSV } from 'react-admin'
import Pagination from "../Components/Pagination";
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import { exportExcelResult, getDiscountForExportExcel, deleteNullPropertyValueDiscountFilter, exporter } from './index'


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));

const discountTypes = {
    FINAL_PRICE:
    {
        en: 'FINAL_PRICE',
        fa: 'قیمت نهایی'
    },
    PERCENT:
    {
        en: 'PERCENT',
        fa: 'درصدی'
    }
};

const convertToShamsi = (date: any) => {
    let dateP = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: 'IRAN' })).toLocaleString('fa-IR-u-nu-latn')
    return dateP;
}

export const ListDiscount = (props: ListProps): React.ReactElement => {
    const classes = useStyles();
    const [filterList, setFilterList] = React.useState({
        code: { contains: '' },
        description: { contains: '' },
        createdBy: 'ADMIN',
        tags: []
    });

    const handleDeleteTag = (chipToDelete) => () => {
        setFilterList({ ...filterList, tags: filterList.tags.filter((tag) => tag.key !== chipToDelete.key) })
    };

    const handleAddTag = (e, newTagLabel) => {
        let existTag = filterList.tags.some(t => t?.key === newTagLabel.toUpperCase())
        if (!existTag && newTagLabel !== "")
            setFilterList({ ...filterList, tags: [...filterList.tags, { key: newTagLabel.toUpperCase(), label: newTagLabel }] })
    }

    const ListActions = (props: any) => {
        return (
            <TopToolbar>
                <Button color="primary" href={process.env.REACT_APP_AUTH_PUBLIC_PATH + "/#/create-discount/"}>جدید</Button>
                <Button color="primary" href={process.env.REACT_APP_AUTH_PUBLIC_PATH + "/#/create-discount-grouply/"}>ایجاد گروهی</Button>
                <Button onClick={exportToExcel}>خروجی اکسل</Button>
            </TopToolbar>
        )
    };

    const exportToExcel = async () => {
        await exporter(filterList)
    }

    const enabledType = [
        {
            value: 'ADMIN',
            label: 'ساخته شده توسط ادمین',
            default: true
        },
        {
            value: 'BOTH',
            label: 'نمایش همه محصولات',
            default: false
        },
        
        {
            value: 'SYSTEM',
            label: 'ساخته شده توسط سیستم',
            default: false
        }
    ];


    return (
        <>
            {/* Search Panel */}
            <div className='search-panel' style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column', gap: '0.5rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem', width: '100%' }}>
                        <SearchTextInput
                            fullWidth
                            id="outlined-select-currency-native"
                            onChange={(e) => setFilterList({ ...filterList, code: { contains: e.target.value } })}
                            variant="outlined"
                            value={filterList.code.contains}
                            placeholder="کد"
                        >
                        </SearchTextInput>
                        <SearchTextInput
                            fullWidth
                            id="outlined-select-currency-native"
                            onChange={(e) => setFilterList({ ...filterList, description: { contains: e.target.value } })}
                            variant="outlined"
                            value={filterList.description.contains}
                            placeholder="توضیحات"
                        >
                        </SearchTextInput>
                        <SearchTextInput
                            id="outlined-select-currency-native"
                            select
                            onChange={(e: any) => setFilterList({ ...filterList, createdBy: e.target.value})}
                            variant="outlined"
                            fullWidth                                       
                            value={filterList.createdBy}                   
                        >
                            {enabledType.map((option) => (
                                <option key={option.value} value={option.value} >
                                    {option.label}
                                </option>
                            ))}
                        </SearchTextInput>
                        {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                            <p className="text-IranSans-Bold">ایجاد شده توسط ادمین</p>
                            <Switch
                                checked={filterList.createdBy.not ? true : false}
                                onChange={e => setFilterList({ ...filterList, createdBy: { not: e.target.checked ? 'LIMOOME_SHOP' : '' } })}
                                color="primary"
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </div> */}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', width: '100%' }}>
                        <div className={classes.root}>
                            {filterList.tags?.map((data) => {
                                return (
                                    <li key={data.key}>
                                        <Chip
                                            label={data.label}
                                            onDelete={handleDeleteTag(data)}
                                            className={classes.chip}
                                            variant="outlined"
                                        />
                                    </li>
                                );
                            })}

                        </div>
                        <SearchTextInput fullWidth onBlur={(e) => handleAddTag(e, e.target.value)} size="medium" label="تگ" variant="outlined"></SearchTextInput>
                    </div>
                </div>
            </div>
            <List
                {...props}
                bulkActionButtons={false}
                title={"لیست تخفیف‌ها"}
                perPage={50}
                pagination={<Pagination />}
                sort={{ field: 'updatedAt', order: 'DESC' }}
                actions={<ListActions />}
                filter={filterList}
                exporter={exporter}
            >
                <Datagrid rowClick="show">
                    <TextField
                        label="کد تخفیف"
                        source="code"
                    />
                    <FunctionField
                        label="نوع تخفیف"
                        render={(record: any) => record.discountType}
                        sortable={false}
                    />
                    <TextField
                        label="تعداد"
                        source="count"
                    />
                    <FunctionField
                        label="فعال"
                        render={(record: any) => record.isEnabled ? "فعال" : "غیرفعال"}
                    />
                    <FunctionField
                        label="تاریخ به‌روزرسانی"
                        source="updatedAt"
                        render={(record: any) => convertToShamsi(record.updatedAt)}
                    />
                    <FunctionField
                        label=""
                        render={(record: any) => <Button color="primary" href={process.env.REACT_APP_AUTH_PUBLIC_PATH + "/#/edit-discount?id=" + record.id}>ویرایش</Button>}
                    />
                </Datagrid>
            </List>
        </>
    )
}